module.exports = __webpack_public_path__ + "img/works_starfield_e_btm_off_m.b6b786be.jpg";